import { Ath0201CtlrIn, Ath0201CtlrOut } from 'app/core/models/api/ath/ath0201'
import { Ath0203CtlrIn, Ath0203CtlrOut } from 'app/core/models/api/ath/ath0203'
import { api } from 'app/core/services/base/api.service'
import { CommonResponse } from 'app/core/services/base/response.service'

/**
 * 파일명 : OCR Service API
 * history : 2025-05-19 : 최초작업
 */

let suffixPath = 'com/ath'

export const postApi = api.injectEndpoints({
    endpoints: (build) => ({
        selectAth0201: build.query<Ath0201CtlrOut, Ath0201CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath02/ath0201`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Ath0201CtlrOut>,
            extraOptions: { handleLocally: true },
        }),
        selectAth0203: build.query<Ath0203CtlrOut, Ath0203CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath02/ath0203`,
                method: 'POST',
                body,
                // headers: { test_skip: 'Y' },
            }),
            transformResponse: CommonResponse<Ath0203CtlrOut>,
            extraOptions: { handleLocally: true },
        }),
    }),
})

export const { useLazySelectAth0201Query, useLazySelectAth0203Query } = postApi

export const {
    endpoints: { selectAth0201, selectAth0203 },
} = postApi
